<div class="d-flex flex-lg-row flex-column align-items-center">
  <div class="d-flex justify-content-around">
    <div
      class="d-flex flex-column justify-content-center align-items-center text-center me-lg-3"
    >
      <span class="fw-bold text-nowrap">Kcal</span>
      <span *ngIf="!tracked">{{ macros?.kcal! | truncate }} kcal</span>
      <span *ngIf="tracked">{{ macros?.selectedKcal! | truncate }} kcal</span>
      <span *ngIf="!tracked"
        >{{ macros?.kcalDividedWeight! | truncate }} kcal/kg</span
      >
    </div>

    <div
      class="d-flex flex-column justify-content-center align-items-center text-center me-lg-3"
    >
      <span class="fw-bold text-nowrap protein-text">Proteínas</span>
      <span *ngIf="!tracked">{{ macros?.proteins! | truncate }} gr</span>
      <span *ngIf="tracked">{{ macros?.selectedProteins! | truncate }} gr</span>
      <span *ngIf="!tracked"
        >{{ macros?.proteinsDividedWeight! | truncate }} gr/kg</span
      >
    </div>
  </div>

  <div class="d-flex justify-content-around">
    <div
      class="d-flex flex-column justify-content-center align-items-center text-center me-lg-3"
    >
      <span class="fw-bold text-nowrap carbohydrates-text">Carbohidratos</span>
      <span *ngIf="!tracked">{{ macros?.carbohydrates! | truncate }} gr</span>
      <span *ngIf="tracked"
        >{{ macros?.selectedCarbohydrates! | truncate }} gr</span
      >
      <span *ngIf="!tracked"
        >{{ macros?.carbohydratesDividedWeight! | truncate }} gr/kg</span
      >
    </div>

    <div
      class="d-flex flex-column justify-content-center align-items-center text-center"
    >
      <span class="fw-bold fats-text">Grasas</span>
      <span *ngIf="!tracked">{{ macros?.fats! | truncate }} gr</span>
      <span *ngIf="tracked">{{ macros?.selectedFats! | truncate }} gr</span>
      <span *ngIf="!tracked"
        >{{ macros?.fatsDividedWeight! | truncate }} gr/kg</span
      >
    </div>
  </div>
</div>
